<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> RELATÓRIO DE EMPRESAS </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <alert
        :type="typeAlert"
        :visible="showAlert"
        :message="messageAlert"
        :clickClose="() => (showAlert = false)"
      ></alert>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="6" md="2">
              <v-select
                v-model="typeCompany"
                :items="types"
                label="Tipo de Empresa"
                outlined
                hide-details
                multiple
                dense
                class="mt-1"
              >
                <template v-slot:prepend-item>
                  <v-list-item ripple @mousedown.prevent @click="toggle">
                    <v-list-item-action>
                      <v-icon
                        :color="typeCompany.length > 0 ? 'indigo darken-4' : ''"
                      >
                        {{ iconSelectTypes }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title> Todos </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template v-slot:selection="{ index, item }">
                  <span v-if="typeCompany.length === 3 && index === 0"
                    >Todos</span
                  >
                  <span v-if="typeCompany.length < 3" class="black--text">
                    {{ item.text }}
                  </span>
                  <span
                    v-if="
                      typeCompany.length < 3 && index !== typeCompany.length - 1
                    "
                  >
                    {{ `,&nbsp; ` }}
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-select
                v-model="status"
                :items="statusCompany"
                class="mt-1"
                label="Status"
                outlined
                dense
                hide-details
              >
              </v-select>
              <!-- <v-switch
                v-model="status"
                class="mt-4"
                label="Mostrar Inativas"
                :false-value="0"
                :true-value="1"
              ></v-switch> -->
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-select
                v-model="selectedRegions"
                :items="regions"
                label="Região"
                outlined
                hide-details
                multiple
                dense
                item-text="description"
                item-value="name"
                class="mt-1"
              >
                <template v-slot:prepend-item>
                  <v-list-item ripple @mousedown.prevent @click="toggleRegion">
                    <v-list-item-action>
                      <v-icon
                        :color="
                          selectedRegions.length > 0 ? 'indigo darken-4' : ''
                        "
                      >
                        {{ iconSelectedRegion }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title> Todos </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template v-slot:selection="{ index, item }">
                  <span v-if="selectedRegions.length === 1">{{
                    item.description
                  }}</span>
                  <span v-if="index === 1" class="black--text">
                    {{ selectedRegions.length }} selecionados
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-select
                v-model="selectedUfs"
                :items="ufs"
                label="UF"
                outlined
                hide-details
                multiple
                dense
                :item-text="(item) => `${item.value} - ${item.description}`"
                item-value="value"
                class="mt-1"
              >
                <template v-slot:prepend-item>
                  <v-list-item ripple @mousedown.prevent @click="toggleUfs">
                    <v-list-item-action>
                      <v-icon
                        :color="selectedUfs.length > 0 ? 'indigo darken-4' : ''"
                      >
                        {{ iconSelectedUf }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title> Todos </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template v-slot:selection="{ index, item }">
                  <span v-if="selectedUfs.length === 1">{{
                    `${item.value} - ${item.description}`
                  }}</span>
                  <span v-if="index === 1" class="black--text">
                    {{ selectedUfs.length }} selecionados
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-select
                v-model="addressComplete"
                :items="yesOrNo"
                class="mt-1"
                label="Endereço Completo"
                outlined
                dense
                hide-details
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="6" md="2">
              <v-select
                v-model="emails"
                :items="typesContacts"
                :item-text="(item) => `Email ${item.name}`"
                item-value="id"
                label="Email"
                outlined
                hide-details
                multiple
                dense
                class="mt-1"
              >
                <template v-slot:prepend-item>
                  <v-list-item
                    ripple
                    @mousedown.prevent
                    @click="toggleEmails()"
                  >
                    <v-list-item-action>
                      <v-icon
                        :color="emails.length > 0 ? 'indigo darken-4' : ''"
                      >
                        {{ iconSelectedEmail }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title> Todos </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template v-slot:selection="{ index, item }">
                  <span v-if="emails.length === 1">{{ item.name }}</span>
                  <span v-if="index === 1" class="black--text">
                    {{ emails.length }} selecionados
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-select
                v-model="phones"
                :items="typesContacts"
                :item-text="(item) => `Telefone ${item.name}`"
                item-value="id"
                label="Telefone"
                outlined
                hide-details
                multiple
                dense
                class="mt-1"
              >
                <template v-slot:prepend-item>
                  <v-list-item
                    ripple
                    @mousedown.prevent
                    @click="togglePhones()"
                  >
                    <v-list-item-action>
                      <v-icon
                        :color="phones.length > 0 ? 'indigo darken-4' : ''"
                      >
                        {{ iconSelectedPhone }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title> Todos </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template v-slot:selection="{ index, item }">
                  <span v-if="phones.length === 1">{{ item.name }}</span>
                  <span v-if="index === 1" class="black--text">
                    {{ phones.length }} selecionados
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-select
                v-model="cellphones"
                :items="typesContacts"
                :item-text="(item) => `Celular ${item.name}`"
                item-value="id"
                label="Celular"
                outlined
                hide-details
                multiple
                dense
                class="mt-1"
              >
                <template v-slot:prepend-item>
                  <v-list-item
                    ripple
                    @mousedown.prevent
                    @click="toggleCellphones()"
                  >
                    <v-list-item-action>
                      <v-icon
                        :color="cellphones.length > 0 ? 'indigo darken-4' : ''"
                      >
                        {{ iconSelectedCellphone }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title> Todos </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template v-slot:selection="{ index, item }">
                  <span v-if="cellphones.length === 1">{{ item.name }}</span>
                  <span v-if="index === 1" class="black--text">
                    {{ cellphones.length }} selecionados
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-select
                v-model="whatsapps"
                :items="typesContacts"
                :item-text="(item) => `Whatsapp ${item.name}`"
                item-value="id"
                label="Whatsapp"
                outlined
                hide-details
                multiple
                dense
                class="mt-1"
              >
                <template v-slot:prepend-item>
                  <v-list-item
                    ripple
                    @mousedown.prevent
                    @click="toggleWhatsapps()"
                  >
                    <v-list-item-action>
                      <v-icon
                        :color="whatsapps.length > 0 ? 'indigo darken-4' : ''"
                      >
                        {{ iconSelectedWhatsapp }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title> Todos </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template v-slot:selection="{ index, item }">
                  <span v-if="whatsapps.length === 1">{{ item.name }}</span>
                  <span v-if="index === 1" class="black--text">
                    {{ whatsapps.length }} selecionados
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-btn
                dark
                color="blue darken-3"
                small
                class="mt-2"
                @click="getCompanies()"
              >
                Executar Consulta
              </v-btn>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-btn
                :disabled="logs.length == 0"
                @click="exportReport('excel')"
                color="grey darken-4"
                outlined
                small
                class="mt-3 float-right"
              >
                <v-icon color="green" left> mdi-file-excel-box </v-icon>
                Excel
              </v-btn>
              <v-btn
                :disabled="logs.length == 0"
                @click="exportPdfSelectType()"
                color="grey darken-4"
                outlined
                small
                class="mt-3 mr-1 float-right"
              >
                <v-icon color="red" left> mdi-file-pdf-box </v-icon>
                PDF
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-1">
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-simple-table dense fixed-header height="380">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left fs-12 text-no-wrap">
                                Código
                              </th>
                              <th class="text-left fs-12 text-no-wrap">Nome</th>
                              <th class="text-left fs-12 text-no-wrap">
                                Função
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Status
                              </th>
                              <th
                                class="text-left fs-12 text-no-wrap"
                                v-if="showAddress"
                              >
                                Cidade/Shopping ou Bairro
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                CPF/CNPJ
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Inscrição Estadual
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Contato
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Email Pedido
                              </th>
                              <th
                                class="text-left fs-12 text-no-wrap"
                                v-if="showAddress"
                                style="min-width: 200px"
                              >
                                Endereço
                              </th>
                              <th
                                class="text-left fs-12 text-no-wrap"
                                v-if="showAddress"
                              >
                                Cidade
                              </th>
                              <th
                                class="text-left fs-12 text-no-wrap"
                                v-if="showAddress"
                              >
                                UF
                              </th>
                              <th
                                v-for="email in emails"
                                :key="`email-${email}`"
                                class="text-left fs-12 text-no-wrap"
                              >
                                Email {{ capitalizeFirstLetter(email) }}
                              </th>
                              <th
                                v-for="phone in phones"
                                :key="`phone-${phone}`"
                                class="text-left fs-12 text-no-wrap"
                              >
                                Telefone {{ capitalizeFirstLetter(phone) }}
                              </th>
                              <th
                                v-for="cellphone in cellphones"
                                :key="`cellphone-${cellphone}`"
                                class="text-left fs-12 text-no-wrap"
                              >
                                Celular {{ capitalizeFirstLetter(cellphone) }}
                              </th>
                              <th
                                v-for="whatsapp in whatsapps"
                                :key="`whatsapp-${whatsapp}`"
                                class="text-left fs-12 text-no-wrap"
                              >
                                Whatsapp {{ capitalizeFirstLetter(whatsapp) }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="log in logs" :key="log.id">
                              <td>
                                {{ log.code }}
                              </td>
                              <td class="text-no-wrap">
                                {{ log.name }}
                              </td>
                              <td>
                                {{ getTypeName(log.type) }}
                              </td>
                              <td>
                                {{ log.status == "1" ? "Ativo" : "Inativo" }}
                              </td>
                              <td v-if="showAddress">
                                {{ log.description }}
                              </td>
                              <td>
                                {{ log.document }}
                              </td>
                              <td>
                                {{ log.state_registration }}
                              </td>
                              <td class="text-no-wrap">
                                {{ log.contact_name }}
                              </td>
                              <td v-html="extractEmail(log.email)"></td>
                              <td v-if="showAddress" style="width: 200px">
                                {{ getFullAddress(log) }}
                              </td>
                              <td v-if="showAddress">
                                {{
                                  `${
                                    log.delivery_city == null
                                      ? ""
                                      : log.delivery_city
                                  }`
                                }}
                              </td>
                              <td v-if="showAddress">
                                {{
                                  `${
                                    log.delivery_state == null
                                      ? ""
                                      : log.delivery_state
                                  }`
                                }}
                              </td>
                              <td
                                v-for="email in log.emails_content"
                                :key="`email-body-${email.header}`"
                                class="text-left fs-12 text-no-wrap"
                                v-html="extractContactsColumn(email.data)"
                              ></td>
                              <td
                                v-for="phone in log.phones_content"
                                :key="`phone-body-${phone.header}`"
                                class="text-left fs-12 text-no-wrap"
                                v-html="extractContactsColumn(phone.data)"
                              ></td>
                              <td
                                v-for="cellphone in log.cellphones_content"
                                :key="`cellphone-body-${cellphone.header}`"
                                class="text-left fs-12 text-no-wrap"
                                v-html="extractContactsColumn(cellphone.data)"
                              ></td>
                              <td
                                v-for="whatsapp in log.whatsapps_content"
                                :key="`whatsapp-body-${whatsapp.header}`"
                                class="text-left fs-12 text-no-wrap"
                                v-html="extractContactsColumn(whatsapp.data)"
                              ></td>
                            </tr>
                          </tbody>
                          <tfoot v-if="logs.length > 0">
                            <tr>
                              <th colspan="40">
                                Total de Empresas:
                                {{ logs.length }}
                              </th>
                            </tr>
                          </tfoot>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="400"
      v-model="linkDownload"
    >
      <v-card>
        <v-card-text class="pa-10">
          <v-btn
            class="ma-5 white--text justify-center d-flex"
            large
            color="indigo"
            target="_blank"
            :href="download.link"
            @click="() => (linkDownload = false)"
          >
            <v-icon left>mdi-cloud-download</v-icon>
            CLIQUE AQUI PARA BAIXAR
          </v-btn>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="linkDownload = false">
            FECHAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="400"
      v-model="dialogSelectPdfType"
    >
      <v-card>
        <v-card-title> Relatório empresa </v-card-title>
        <v-card-text class="pa-5">
          <p>Selecione o tipo de relatório das empresas em PDF</p>
          <v-btn
            class="ma-5 justify-center"
            large
            outlined
            :disabled="disableTypeTable"
            color="indigo"
            @click="exportReport('pdf')"
          >
            <v-icon left>mdi-file-table-outline</v-icon>
            Tabela
          </v-btn>
          <v-btn
            class="ma-5 justify-center"
            large
            outlined
            color="green darken-3"
            @click="exportReport('pdf-data-company')"
          >
            <v-icon left>mdi-file-document-multiple-outline</v-icon>
            Ficha
          </v-btn>
          <p class="text-caption blue--text mt-5">
            O tipo Tabela só é liberado para relatório com menos de 10 colunas
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogSelectPdfType = false">
            FECHAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { URL } from "@/api/config";
import { UF_REGIONS, REGIONS } from "@/api/constants";
import Alert from "@/components/Alert";

export default {
  components: { Alert },
  data: () => ({
    types: [
      {
        value: "fra",
        text: "Franquias",
      },
      {
        value: "mul",
        text: "Multimarcas",
      },
      {
        value: "for",
        text: "Fornecedores",
      },
    ],
    typeCompany: ["fra", "mul"],
    regions: [],
    selectedRegions: [],
    ufs: [],
    selectedUfs: [],
    status: "1",
    statusCompany: [
      {
        value: "",
        text: "Todos",
      },
      {
        value: "1",
        text: "Ativos",
      },
      {
        value: "0",
        text: "Inativos",
      },
    ],
    loading: false,
    successSave: false,
    lazy: false,
    valid: true,
    logs: [],
    showAlert: false,
    typeAlert: "error",
    messageAlert: "",
    addressComplete: "y",
    yesOrNo: [
      {
        value: "y",
        text: "Sim",
      },
      {
        value: "n",
        text: "Não",
      },
    ],
    linkDownload: false,
    download: {
      name: "",
      link: "#",
    },
    typesContacts: [
      {
        id: "loja",
        name: "Loja",
      },
      {
        id: "franqueado",
        name: "Franqueado",
      },
      {
        id: "gerente",
        name: "Gerente",
      },
      {
        id: "cobrança",
        name: "Cobrança",
      },
      {
        id: "nfe",
        name: "Recebimento NFE",
      },
    ],
    emails: [],
    cellphones: [],
    phones: [],
    whatsapps: [],
    showAddress: true,
    dialogSelectPdfType: false,
    disableTypeTable: true,
  }),
  computed: {
    allTypesSelected() {
      return this.typeCompany.length === this.types.length;
    },
    someTypesSelected() {
      return this.typeCompany.length > 0 && !this.allTypesSelected;
    },
    iconSelectTypes() {
      if (this.allTypesSelected) return "mdi-close-box";
      if (this.someTypesSelected) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    allRegionsSelected() {
      return this.selectedRegions.length === this.regions.length;
    },
    someRegionsSelected() {
      return this.selectedRegions.length > 0 && !this.allRegionsSelected;
    },
    iconSelectedRegion() {
      if (this.allRegionsSelected) return "mdi-close-box";
      if (this.someRegionsSelected) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    allUfsSelected() {
      return this.selectedUfs.length === this.ufs.length;
    },
    someUfsSelected() {
      return this.selectedUfs.length > 0 && !this.allUfsSelected;
    },
    iconSelectedUf() {
      if (this.allUfsSelected) return "mdi-close-box";
      if (this.someUfsSelected) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    allEmailsSelected() {
      return this.emails.length === this.typesContacts.length;
    },
    someEmailsSelected() {
      return this.emails.length > 0 && !this.allEmailsSelected;
    },
    iconSelectedEmail() {
      if (this.allEmailsSelected) return "mdi-close-box";
      if (this.someEmailsSelected) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    allPhonesSelected() {
      return this.phones.length === this.typesContacts.length;
    },
    somePhonesSelected() {
      return this.phones.length > 0 && !this.allPhonesSelected;
    },
    iconSelectedPhone() {
      if (this.allPhonesSelected) return "mdi-close-box";
      if (this.somePhonesSelected) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    allCellphonesSelected() {
      return this.cellphones.length === this.typesContacts.length;
    },
    someCellphonesSelected() {
      return this.cellphones.length > 0 && !this.allCellphonesSelected;
    },
    iconSelectedCellphone() {
      if (this.allCellphonesSelected) return "mdi-close-box";
      if (this.someCellphonesSelected) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    allWhatsappsSelected() {
      return this.whatsapps.length === this.typesContacts.length;
    },
    someWhatsappsSelected() {
      return this.whatsapps.length > 0 && !this.allWhatsappsSelected;
    },
    iconSelectedWhatsapp() {
      if (this.allWhatsappsSelected) return "mdi-close-box";
      if (this.someWhatsappsSelected) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      // this.typeCompany = this.types.map((item) => item.value);
      this.regions = REGIONS;
      this.ufs = UF_REGIONS;

      this.selectedUfs = this.ufs.map((item) => item.value);
      this.selectedRegions = this.regions.map((item) => item.name);
      // await this.getCompanies();
    },
    toggle() {
      this.$nextTick(() => {
        if (this.allTypesSelected) {
          this.typeCompany = [];
        } else {
          this.typeCompany = this.types.map((item) => item.value);
        }
      });
    },
    toggleRegion() {
      this.$nextTick(() => {
        if (this.allRegionsSelected) {
          this.selectedRegions = [];
        } else {
          this.selectedRegions = this.regions.map((item) => item.name);
        }
      });
    },
    toggleUfs() {
      this.$nextTick(() => {
        if (this.allUfsSelected) {
          this.selectedUfs = [];
        } else {
          this.selectedUfs = this.ufs.map((item) => item.value);
        }
      });
    },
    toggleEmails() {
      this.$nextTick(() => {
        if (this.allEmailsSelected) {
          this.emails = [];
        } else {
          this.emails = this.typesContacts.map((item) => item.id);
        }
      });
    },
    togglePhones() {
      this.$nextTick(() => {
        if (this.allPhonesSelected) {
          this.phones = [];
        } else {
          this.phones = this.typesContacts.map((item) => item.id);
        }
      });
    },
    toggleCellphones() {
      this.$nextTick(() => {
        if (this.allCellphonesSelected) {
          this.cellphones = [];
        } else {
          this.cellphones = this.typesContacts.map((item) => item.id);
        }
      });
    },
    toggleWhatsapps() {
      this.$nextTick(() => {
        if (this.allWhatsappsSelected) {
          this.whatsapps = [];
        } else {
          this.whatsapps = this.typesContacts.map((item) => item.id);
        }
      });
    },
    validate() {},
    async getCompanies() {
      this.showAlert = false;
      this.loading = true;
      this.logs = [];
      let data = {
        status: this.status,
        types: this.typeCompany,
        regions: this.selectedRegions,
        ufs: this.selectedUfs,
        emails: this.emails,
        phones: this.phones,
        cellphones: this.cellphones,
        whatsapps: this.whatsapps,
        report: "companies",
      };
      this.showAddress = this.addressComplete === "y";
      try {
        let response = await fetch(`${URL}report/report-company?`, {
          method: "POST",
          body: JSON.stringify(data),
          headers: new Headers({
            "Content-Type": "application/json",
          }),
        });
        let res = await response.json();
        this.logs = res;
      } catch (error) {
        this.messageAlert =
          "Não foi possível carregar as Empresas, tente novamente mais tarde";
        this.typeAlert = "error";
        this.showAlert = true;
      } finally {
        this.loading = false;
      }
    },
    async exportReport(type) {
      this.dialogSelectPdfType = false;
      this.download = {
        name: "",
        link: "#",
      };
      this.linkDownload = false;
      let data = {};
      data.logs = this.logs;
      data.showAddress = this.showAddress;
      data.emails = this.emails;
      data.phones = this.phones;
      data.cellphones = this.cellphones;
      data.whatsapps = this.whatsapps;

      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}report/export-company/${type}`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        if (!res.ok) {
          throw new Error(res.message);
        }
        let response = await res.json();
        this.download.name = response.nome;
        this.download.link = `${URL}report/download-company/${response.nome}`;
        this.linkDownload = true;
      } catch (error) {
        console.log(error);
      }
    },
    getTypeName(type) {
      let arrType = {
        fra: "Franquia",
        for: "Fornecedor",
        mul: "Multimarcas",
      };
      return arrType[type];
    },
    getFullAddress(log) {
      let address = [];
      if (log.delivery_address != null) {
        address.push(log.delivery_address);
      }
      if (log.delivery_number != null) {
        address.push(log.delivery_number);
      }
      if (log.delivery_complement != null) {
        address.push(log.delivery_complement);
      }
      return address.join(", ");
    },
    capitalizeFirstLetter(str) {
      if (str === "") return "";
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    extractContactsColumn(contacts) {
      if (contacts.length === 0) return "";
      return contacts
        .map((item) => ({
          name: item.name,
          type: item.method,
          contact: item.contact,
        }))
        .map(this.formatItemColumn)
        .join("<br />");
    },
    extractEmail(email) {
      if (email === "" || email === null || email === undefined) return "";
      return email
        .split(";")
        .map((item) => `<a href="mailto:${email}">${item}</a>`)
        .join("<br />");
    },
    formatItemColumn(item) {
      // if (item.type === "telefone" || item.type === "celular") {
      //   return `<a href="tel:${item.contact}">${item.contact}</a> (${item.name})`;
      // } else
      if (item.type === "email") {
        return `<a href="mailto:${item.contact}">${item.contact}</a> (${item.name})`;
      } else if (item.type === "whatsapp") {
        return `<a target="_blank" href="https://wa.me/55${this.phoneOnlyNumbers(
          item.contact
        )}">${item.contact}</a> (${item.name})`;
      } else {
        return `${item.contact} (${item.name})`;
      }
    },
    phoneOnlyNumbers(number) {
      if (number === "" || number === null || number === undefined) return "";
      return number
        .replace(/\s/g, "")
        .replace(/-/g, "")
        .replace(/\(/g, "")
        .replace(/\)/g, "");
    },
    exportPdfSelectType() {
      let columns = 8;
      if (this.showAddress) {
        columns += 4;
      }
      if (this.emails.length > 0) {
        columns += this.emails.length;
      }
      if (this.phones.length > 0) {
        columns += this.phones.length;
      }
      if (this.cellphones.length > 0) {
        columns += this.cellphones.length;
      }
      if (this.whatsapps.length > 0) {
        columns += this.whatsapps.length;
      }
      console.log(columns);
      if (columns <= 12) {
        this.disableTypeTable = false;
      }
      this.dialogSelectPdfType = true;
    },
  },
};
</script>
<style scoped>
.v-data-table {
  overflow-x: auto;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 11.5px;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}
.v-data-table__wrapper table tfoot th {
  position: sticky;
  bottom: 0;
  background: #fff;
}
</style>
<style>
.text-area-uppercase textarea {
  text-transform: uppercase;
}
</style>
